











import { Component, Vue, Prop } from "vue-property-decorator";
import AnalysisItem from "../analysis-item/AnalysisItem.vue";
import { Analysis } from "@/api/analyses/types";

@Component({
  name: "FarmViewAnalysesList",
  components: {
    AnalysisItem
  }
})
export default class AnalysesList extends Vue {
  @Prop({ type: Array, required: true })
  private analysesList!: Analysis[];

  get sortedAnalysesList() {
    return this.analysesList.flat().sort((a, b) => (a.createdAt! === b.createdAt!) ? 0 :((a.createdAt! > b.createdAt!) ? -1 : 1));
  }

  private sendAnalysisToDelete(analysis: Analysis) {
    this.$emit("analysis:delete", analysis);
  }
}
